import {useMutation} from "@tanstack/react-query";
import {setPermissionOverrideMutationOptions} from "./set-permission-override.mutation-options";

export function useSetPermissionOverride(userId: string) {
  return useMutation(setPermissionOverrideMutationOptions(userId));
}
